import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-search-btn',
  templateUrl: './search-btn.component.html',
  styleUrls: ['./search-btn.component.scss']
})
export class SearchBtnComponent {
  @Output() public btnClick = new EventEmitter();
  @Input() public disabled = true;
}
